export default __webpack_public_path__ + "static/media/GenSekiGothicTW-R-01.6922346a.woff";